export default "__VITE_ASSET__577c0269__"